import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { AttendeeDetails } from '@/features/desktop/types/attendee-details';

export const getAttendeeStats = (badgeNo: string): Promise<AttendeeDetails> => {
  return axios.get(`0/onsite/stats/${badgeNo}`);
};

type QueryFnType = typeof getAttendeeStats;

type UseOptions = {
  badgeNo: string;
  config?: QueryConfig<QueryFnType>;
};

export const useAttendeeStats = ({ badgeNo, config }: UseOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['onsite_attendee_stats', `${badgeNo}`],
    queryFn: () => getAttendeeStats(badgeNo),
    ...config,
  });
};
